/**
 * Date and DOB utilities for counter orders
 * Pure functions - no dependencies on component state
 */
class DateUtils {
  /**
   * Format date parts to YYYY-MM-DD string
   */
  static formatDobParts(date) {
    if (!(date instanceof Date)) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  /**
   * Normalize DOB value to YYYY-MM-DD format
   * Handles various input formats: Date objects, ISO strings, MM/DD/YYYY, YYYYMMDD, etc.
   */
  static normalizeDobValue(value) {
    if (!value) {
      return null;
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return DateUtils.formatDobParts(value);
    }

    const stringValue = value.toString().trim();
    if (!stringValue) {
      return null;
    }

    let parsedDate = null;

    const timestamp = Date.parse(stringValue);
    if (!Number.isNaN(timestamp)) {
      parsedDate = new Date(timestamp);
    }

    if (!parsedDate) {
      const digitsOnly = stringValue.replace(/\D/g, "");
      if (digitsOnly.length === 8) {
        // Try YYYYMMDD format first
        const yyyyFirst = digitsOnly.slice(0, 4);
        const mmFirst = digitsOnly.slice(4, 6);
        const ddFirst = digitsOnly.slice(6, 8);
        const firstCandidate = new Date(
          Number(yyyyFirst),
          Number(mmFirst) - 1,
          Number(ddFirst)
        );
        if (
          !Number.isNaN(firstCandidate.getTime()) &&
          firstCandidate.getFullYear() === Number(yyyyFirst) &&
          firstCandidate.getMonth() === Number(mmFirst) - 1 &&
          firstCandidate.getDate() === Number(ddFirst)
        ) {
          parsedDate = firstCandidate;
        } else {
          // Try MMDDYYYY format
          const mmSecond = digitsOnly.slice(0, 2);
          const ddSecond = digitsOnly.slice(2, 4);
          const yyyySecond = digitsOnly.slice(4, 8);
          const secondCandidate = new Date(
            Number(yyyySecond),
            Number(mmSecond) - 1,
            Number(ddSecond)
          );
          if (
            !Number.isNaN(secondCandidate.getTime()) &&
            secondCandidate.getFullYear() === Number(yyyySecond) &&
            secondCandidate.getMonth() === Number(mmSecond) - 1 &&
            secondCandidate.getDate() === Number(ddSecond)
          ) {
            parsedDate = secondCandidate;
          }
        }
      }
    }

    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return DateUtils.formatDobParts(parsedDate);
  }
}

export default DateUtils;




// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/utils/DateUtils.js